import type { OptionsDocument, Pipeline } from 'paintscout'

export function reorderPipelines(args: { options: OptionsDocument; pipelines: Pipeline[] }): OptionsDocument {
  const { options, pipelines } = args
  return {
    ...options,
    options: {
      ...options.options,
      pipelines: {
        ...options.options.pipelines,
        order: pipelines.map((item: Pipeline) => item.key)
      }
    }
  }
}
